module.exports = __webpack_public_path__ + "media/img/help_center/Student_Account_Creation_01-8f8982efbefc6adb05df8e775a55fdc2.jpg";